<template>
  <div class="ss-card-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag" class="card-content">
      <!-- Status Section -->
      <div class="status-section">
        <div class="section-icon">
          <v-icon>mdi-check-circle</v-icon>
        </div>
        <div class="section-content">
          <div class="section-label">Document Status</div>
          <v-chip draggable dark small :color="Document.LomDocumentStatusColor" text-color="white" class="status-chip">
            {{ ResultFlag ? Document.LomDocumentStatusTxt : "Pending" }}
          </v-chip>
        </div>
        <v-btn icon class="refresh-btn" @click="refreshPageData" :loading="SkeletonLoadingFlag">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>

      <!-- Document Label -->
      <div class="document-label">
        <v-icon small class="label-icon">mdi-file-document</v-icon>
        <span>Specimen Signature Card</span>
      </div>

      <!-- Document Section -->
      <div class="document-section">
        <div v-if="Document.LomDocumentFlag" class="document-available">
          <div class="document-row">
            <div class="doc-icon success">
              <v-icon small>mdi-check</v-icon>
            </div>
            <div class="doc-content">
              <span class="doc-title">Document uploaded</span>
              <span class="doc-subtitle">Verified and approved</span>
            </div>
            <v-btn small depressed :href="Document.DocumentAssetPath" target="_blank" class="download-btn">
              <v-icon small left>mdi-download</v-icon>
              Download
            </v-btn>
          </div>
        </div>

        <div v-else class="document-empty">
          <div class="document-row">
            <div class="doc-icon pending">
              <v-icon small>mdi-clock-outline</v-icon>
            </div>
            <div class="doc-content">
              <span class="doc-title">No document uploaded</span>
              <span class="doc-subtitle">Please upload your signature card</span>
            </div>
            <v-btn small depressed class="upload-btn" @click.prevent="uploadDocumentPrompt = true">
              <v-icon small left>mdi-cloud-upload</v-icon>
              Upload
            </v-btn>
          </div>
        </div>
      </div>

      <v-dialog v-model="uploadDocumentPrompt" persistent max-width="70%">
        <voting-rights-create pageTitle="Upload Specimen Signature Card" :addRecordPrompt="uploadDocumentPrompt"
          @hideAddRecordPrompt="hideUploadRecordPrompt" v-if="uploadDocumentPrompt" :SampleFilePath="SampleFilePath" ></voting-rights-create>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import VotingRightsCreate from "../voting-rights/VotingRightsCreate.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
export default {
  mixins: [common],
  components: {
    VotingRightsCreate,
  },
  data() {
    return {
      uploadDocumentPrompt: false,
      EditRecordPrompt: false,

      SkeletonLoadingFlag: true,

      EligibleCount: 0,
      selectedData: {},
      Document: {},
      ResultFlag: false,
      SampleFilePath: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("SScard refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "voting_rights",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
    },
    hideUploadRecordPrompt(flag) {
      console.log("hideUploadRecordPrompt called");
      this.uploadDocumentPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    getTableRecords() {
      console.log("SScard getTableRecords called");

      this.SkeletonLoadingFlag = true;
      this.Document = {};
      this.ResultFlag = false;
      this.SampleFilePath = "";

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom-document/show";
      var upload = {
        UserInterface: 3,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SkeletonLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          var records = response.data.records;
          console.log({ records });

          var options = response.data.options;
          console.log({ options });

          var TableOptions = options.TableOptions;
          console.log({ TableOptions });
          thisIns.SampleFilePath = TableOptions.SampleSSCardPath;

          if (flag) {
            thisIns.ResultFlag = true;
            thisIns.Document = records;
            // thisIns.toast("success", output);
          } else {
            // thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SkeletonLoadingFlag = false;
        });
    },
  },
  mounted() { },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.ss-card-container {
  width: 100%;

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .status-section {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.08) 0%, rgba(58, 103, 177, 0.05) 100%);
    border-radius: 10px;
    border-left: 3px solid #3a67b1;
  }

  .section-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #3a67b1;
    border-radius: 8px;
    color: white;

    .v-icon {
      font-size: 18px;
    }
  }

  .section-content {
    flex: 1;
  }

  .section-label {
    font-size: 10px;
    font-weight: 600;
    color: #414042;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  .status-chip {
    font-weight: 600 !important;
    font-size: 11px !important;
    height: 22px !important;
  }

  .refresh-btn {
    margin-left: auto;
    color: #3a67b1 !important;
    width: 28px !important;
    height: 28px !important;
    transition: all 0.3s ease;

    .v-icon {
      font-size: 18px;
    }

    &:hover {
      background: rgba(58, 103, 177, 0.1) !important;
      transform: rotate(180deg);
    }
  }

  .document-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #414042;
    padding: 0 4px;

    .label-icon {
      color: #3a67b1;
    }
  }

  .document-section {
    padding: 0;
  }

  .document-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
  }

  .doc-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid;

    &.success {
      background: rgba(76, 175, 80, 0.1);
      border-color: #4caf50;
      color: #4caf50;
    }

    &.pending {
      background: rgba(237, 190, 56, 0.1);
      border-color: #edbe38;
      color: #edbe38;
    }
  }

  .doc-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;

    .doc-title {
      font-size: 13px;
      font-weight: 600;
      color: #0a0f29;
    }

    .doc-subtitle {
      font-size: 11px;
      color: #666;
    }
  }

  .document-available {
    .document-row {
      background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
      border: 1px solid rgba(76, 175, 80, 0.3);
    }
  }

  .document-empty {
    .document-row {
      background: linear-gradient(135deg, #fff9c4 0%, #fffde7 100%);
      border: 1px solid rgba(237, 190, 56, 0.4);
    }
  }

  .download-btn {
    background: linear-gradient(135deg, #3a67b1 0%, darken(#3a67b1, 10%) 100%) !important;
    color: white !important;
    padding: 0 12px !important;
    height: 30px !important;
    border-radius: 6px !important;
    font-weight: 600 !important;
    font-size: 11px !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    transition: all 0.3s ease !important;

    &:hover {
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.3);
    }
  }

  .upload-btn {
    background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%) !important;
    color: white !important;
    padding: 0 12px !important;
    height: 30px !important;
    border-radius: 6px !important;
    font-weight: 600 !important;
    font-size: 11px !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    transition: all 0.3s ease !important;

    &:hover {
      box-shadow: 0 4px 12px rgba(237, 190, 56, 0.3);
    }
  }
}
</style>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>